import QuizSubmissionsLayout from 'components/QuizSubmissions/QuizSubmissionsLayout';

const Desktop = (props) => <QuizSubmissionsLayout device={'desktop'} {...props} />;

export default Desktop;
